import { Box } from '@mui/material';
import { useState } from 'react';
import infuserImage from '../../assets/imgs/home/infuser-summary-all.png';

interface AreaConfig {
  id: string;
  top: number;
  left: number;
  width: number;
  height: number;
}

const areas: AreaConfig[] = [
  { id: 'area1', top: 0, left: 0, width: 335, height: 561 },
  { id: 'area2', top: 68, left: 334, width: 334, height: 170 },
  { id: 'area3', top: 238, left: 334, width: 334, height: 230 },
  { id: 'area4', top: 68, left: 666, width: 331, height: 355 },
];

const areaMessages: Record<
  string,
  {
    title: string;
    body: string;
    position: {
      top: number | string;
      left?: number | string;
      right?: number | string;
    };
  }
> = {
  area1: {
    title: 'API 제공 항목 정의',
    body: '제공할 데이터 항목을 GUI 환경에서 직관적으로 정의하여 API 응답 구조를 구성',
    position: { top: 468 - 126 - 20, left: 335 + 10 }, // 오른쪽 아래
  },
  area2: {
    title: 'API 제공 항목 정의',
    body: '제공할 데이터 항목을 GUI 환경에서 직관적으로 정의하여 API 응답 구조를 구성',
    position: { top: 68 + 170 + 10, left: 334 }, // 아래
  },
  area3: {
    title: '사용자 Parameter 정의 및 동작 방식 제공',
    body: '사용자가 입력할 파라미터의 형식, 데이터 타입, 필수 여부 등을 정의하고 입력값 처리 방식까지 함께 설정',
    position: { top: 238 - 178 - 10 - 20, left: 334 }, // 위 (메시지 박스 높이 약 50~60 기준)
  },
  area4: {
    title: 'API 제공 항목 정의',
    body: '작성된 API 설정을 기반으로 OAS (Open API Specification) 표준 문서를 자동 생성하고, Swagger UI를 통해 명확하고 편리한 API 명세를 제공',
    position: { top: 68, left: 666 - 331 - 10 }, // 오른쪽
  },
};

export default function InfuserImageHighlight() {
  const [hoveredArea, setHoveredArea] = useState<string | null>(null);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '997px', // 997px
        height: '561px', // 561px
        backgroundImage: `url(${infuserImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        mx: 'auto',
      }}
    >
      {/* 어두운 오버레이 */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          opacity: hoveredArea ? 1 : 0,
          pointerEvents: 'none',
          transition: 'opacity 0.3s',
          zIndex: 1,
        }}
      />
      {/* 각 강조 영역 */}
      {areas.map((area) => (
        <Box
          key={area.id}
          onMouseEnter={() => setHoveredArea(area.id)}
          onMouseLeave={() => setHoveredArea(null)}
          sx={{
            position: 'absolute',
            top: `${area.top}px`,
            left: `${area.left}px`,
            width: `${area.width}px`,
            height: `${area.height}px`,
            zIndex: hoveredArea === area.id ? 2 : 0,
            backgroundImage: hoveredArea === area.id ? `url(${infuserImage})` : 'none',
            backgroundPosition: `-${area.left}px -${area.top}px`,
            backgroundSize: '997px 561px',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            border: hoveredArea === area.id ? '1px solid #FF0000' : 'none',
          }}
        />
      ))}

      {/* 설명 메시지 */}
      {hoveredArea && areaMessages[hoveredArea] && (
        <Box
          sx={{
            position: 'absolute',
            zIndex: 5, // ← 여기 추가 또는 수정
            ...areaMessages[hoveredArea].position,
            background: 'rgba(255, 255, 255, 0.20)',
            boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.25)',
            border: '1px solid #FFF',
            backdropFilter: 'blur(6px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '24px',
            width: '332px',
          }}
        >
          <Box
            sx={{
              color: '#FFF',
              textAlign: 'center',
              fontSize: '24px',
              fontWeight: '700',
              lineHeight: '28px',
              wordBreak: 'keep-all',
            }}
          >
            {areaMessages[hoveredArea].title}
          </Box>
          {/* 구분선 */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '280px',
              height: '1px',
              mt: '10px',
              mb: '10px',
              gap: '0.625rem',
              borderWidth: '1px 0px 0px 0px',
              borderStyle: 'solid',
              borderImage:
                'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 20%, rgba(255,255,255,0.8) 80%, rgba(255,255,255,0) 100%) 1',
            }}
          />
          <Box
            sx={{
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '25px',
              wordBreak: 'keep-all',
            }}
          >
            {areaMessages[hoveredArea].body}
          </Box>
        </Box>
      )}
    </Box>
  );
}
